import { IconNames } from '@blueprintjs/icons';
import { IconButton } from '@strata/react-buttons';
import { PrimaryData } from '@strata/react-grid';

import { ClientPreferenceCell } from 'pages/therapyGroups/ClientPreferenceCell';
import {
    canRemoveParent,
    clientPreferenceEntries,
    oidsForParent,
} from 'services/TherapyGroupPreferenceHelpers';

const RemoveBlockedTitle =
    'Move the global default to another product before removing this parent product.';

export const therapyGroupOidColumns = ({
    onEdit,
    onRemove,
    preferences,
    parentProducts,
    windows = [],
}) => [
    // The grid lays columns out by proportion of these sizes. Product names, OIDs and the two
    // action icons have predictable widths, so the client preference list gets most of the room.
    {
        header: 'Parent Product Name',
        accessorKey: 'parentDisplayName',
        size: 140,
        enableSorting: false,
        cell: ({ row }) =>
            row.original.isFirstOfParent ? (
                <PrimaryData data={row.original.parentDisplayName} />
            ) : null,
    },
    {
        header: 'OID',
        accessorKey: 'oid',
        size: 180,
        enableSorting: false,
        cell: ({ getValue }) => <PrimaryData data={getValue()} />,
    },
    {
        header: 'Client Preference',
        accessorKey: 'clientPreference',
        size: 700,
        enableSorting: false,
        cell: ({ row }) => (
            <ClientPreferenceCell entries={clientPreferenceEntries(row.original, windows)} />
        ),
    },
    {
        header: 'Actions',
        accessorKey: 'actions',
        size: 80,
        enableSorting: false,
        cell: ({ row }) => {
            const catalogOids = oidsForParent(parentProducts, row.original.parentProductService);
            const parentOids = catalogOids.length > 0 ? catalogOids : [row.original.oid];
            const removable = canRemoveParent(preferences, parentOids);
            return (
                <div className="sds_filter-list__actions">
                    <IconButton
                        icon={IconNames.EDIT}
                        title="Edit client preference"
                        onClick={() => onEdit(row.original.oid)}
                    />
                    {row.original.isFirstOfParent && (
                        <IconButton
                            icon={IconNames.TRASH}
                            title={removable ? 'Remove parent product' : RemoveBlockedTitle}
                            disabled={!removable}
                            onClick={() =>
                                onRemove({
                                    parentProductService: row.original.parentProductService,
                                    displayName: row.original.parentDisplayName,
                                    oids: parentOids,
                                })
                            }
                        />
                    )}
                </div>
            );
        },
    },
];
